const prod = {
    img_path: '/calc/images/cards/',
    img_path_cart: '/calc/images/cards/',
}
const dev = {
    img_path: '/calc/images/cards/',
    img_path_cart: '/calc/images/cards/',
}
export const config = process.env.NODE_ENV === 'development' ? dev : prod
